import repository from "../Repository";

export default {
  async list(screenId) {
    return repository.post(
      "organize_info",
      {},
      {
        headers: {
          s: screenId
        }
      }
    );
  }
};
